// extracted by mini-css-extract-plugin
module.exports = {"is-grid":"Products-module__is-grid___2VY_p"};